import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DropDownService } from '../../Services/DropDown/dropdownService';
import { DropDownRequest, DropDownResponse, RequirmentTypeModel, WHLocationModel } from '../../Models/DropDwon/DropDownRequest';
import { productModel } from '../../Models/DropDwon/ProductModel';
import { ToastrService } from 'ngx-toastr';
import { DispatchToWarehouseService } from '../../Services/DispatchToWarehouse/dispatch-to-warehouse.service';
import { DatePipe } from '@angular/common';
import { YearModel } from 'src/app/Models/DropDwon/YearModel';
import { monthModel } from 'src/app/Models/DropDwon/MonthModel';
import { originLocationModel } from 'src/app/Models/DropDwon/OriginLocationModel';
import { UploadExcel } from 'src/app/models/DSDispatchToSD/AddRow';
import { ChangeDetectorRef } from '@angular/core';
import { forEach } from '@angular/router/src/utils/collection';


@Component({
    selector: 'dispatch-to-warehouse',
    templateUrl: './dispatch-to-warehouse.component.html',
    styleUrls: ['./dispatch-to-warehouse.component.css']
})
export class DispatchToWarehouseComponent implements OnInit {
    
    public loader: string = "none";
    @ViewChild('productSelect') productSelect;
    @ViewChild('WHLocationItem') WHLocationItem;
    @ViewChild('AddRowWHLocation') AddRowWHLocation;
    @ViewChild('AddRowProduct') AddRowProduct;
    @ViewChild('AddRowPackSize') AddRowPackSize;
    @ViewChild('AddRowRecThrough') AddRowRecThrough;
    @ViewChild('monthSelect') monthSelect;
    @ViewChild('AddRowMonth') AddRowMonth;
    @ViewChild('AddRowOriginLocation') AddRowOriginLocation;
    @ViewChild('file') file;
    @ViewChild('year') year;
  
    public form: FormGroup;


    public userId: string;
    public roleId: string;
    public FlagDropDown: string;

    public ddlRequest: DropDownRequest = new DropDownRequest();
    public ddlResponse: DropDownResponse = new DropDownResponse();

    public ddlResponseWH: DropDownResponse = new DropDownResponse();

    public RequirmentTypeSettings = {};
    public requirmentTypeDdl: RequirmentTypeModel[];
    public requirmentDllValue: any;

    public WHLocationSettings = {};
    public whLocationDdl: WHLocationModel[];
    public whLocationDDlValue: any;

    public ProductSettings = {};
    public ProductSelectedItem: productModel[];


    public AddRowWHLocationSettings = {};
    public AddRowWHLocationDDlValue: any;

    public AddRowRequestTypeSettings = {};
    public AddRowRequestTypeDDlValue: any;

    public AddRowProductSettings = {};
    public AddRowProductSelectedItem: productModel[];

    public AddRowReceivedThroughSettings = {};
    public AddRowPackSizeSettings = {};
    
    public MonthSettings = {};
    public MonthSelectedItem: monthModel[];

    public OriginLocationSettings = {};

    public AddRowOriginLocationSettings = {};
    public AddRowOriginLocationSelectedItem: originLocationModel[];

    public AddRowMonthSettings = {};
    public AddRowYearSettings = {};
    public AddRowMonthSelectedItem: monthModel[];

    public YearSettings= {};
    document: UploadExcel = new UploadExcel();
    approvefinalReqDetails: any[] = [];
    reqType: string;
    regionCode: string;
    wareHouseLocation: string;
    selectedReqType: any = [];
    selectedRegion: any = [];
    public files: File[] = [];
    public fileName: string = '';
    defaultView: boolean = true;
    totalRecord: number = 0;
    currentPage: number = 1;
    lastPage: number = 1;
    isDisabledPrevious = true;
    isDisabledNext = false;
    dispatchToSDObj: any = [];
    dispatchToSDWarehouseObj: any[];
    pagination: any;
    userName: string;
    recordsOnCurrentPage: number = 0;
    endRecord: number = 0;
    startRecord: number = 0;
    defaultValue = "none";
    dynamicAddRow: any = [];
    newAddRow: any = {};
    productPackSize: any[] = [];
    displayReject = 'none';
    displayEdit = 'none';
    editStockIn: any = {};
    editProductPackSize: any[] = [];
    currentYear = new Date().getFullYear();
    hiddenFMCSTCloseModel: any;
    remarkInput: any;
    today: Date;
    constructor(private ddlServices: DropDownService, private toastr: ToastrService, private dispatchToWarehouse: DispatchToWarehouseService,private cd: ChangeDetectorRef) {
        this.userId = localStorage.getItem('dsu_userId');
        this.roleId = localStorage.getItem('dsu_roleId');
        this.userName = localStorage.getItem('dsu_userName');
        this.FlagDropDown = (this.roleId == "39" || this.roleId == "43" || this.roleId == "44") ? "Supervisor" : "DEFAULT";
    }

    ngOnInit() {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlServices.getAllHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse = response.data;
                    const years=response.data.year;
                    if (years.length >= 2) {
                        // Extract the last two items
                        debugger;
                        this.ddlResponse.year = years.slice(-2);
                      } else {
                        this.ddlResponse.year = years;
                      }
                    class YearItemList{
                        id: any;
                        text: any;
                    }
                      let requiredItem: YearItemList[] = [];
                      var obj = {
                        id : this.ddlResponse.year[0].currentrequirementYear,
                        text: this.ddlResponse.year[0].currentrequirementYear
                      }
                      requiredItem.push(obj)
                      this.year.selectedItems = requiredItem
                    this.YearSetting();  
                }   
                else {
                    this.toastr.error(response.message);
                }

            }, error => {
            });
       

        this.WHLocationSetting();
        this.GetWarehouseLocationData(this.userId, this.roleId, "TRUE");
        this.ProductSetting();
       // this.YearSetting(); 
        this.MonthSetting();
        this.reqType = '';
        this.regionCode = '';
        this.GetWarehouseData(1);
        this.AddRowWHLocationSetting();
        this.AddRowRequestTypeSetting();
        this.AddRowProductSetting();
        this.AddRowPackSizeSetting();
        this.AddRowMonthSetting();
        this.AddRowOriginLocationSetting();

        this.loader = 'none';
        this.today=new Date();
        this.today.setHours(0, 0, 0, 0); 
    }

    YearSetting(){
        this.YearSettings = {
          singleSelection: true,
          idField: 'year',
          textField: 'year',
          enableCheckAll: false,
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: false,
          limitSelection: -1,
          clearSearchFilter: false,
          itemsShowLimit: 1,
          searchPlaceholderText: 'Search',
          noDataAvailablePlaceholderText: 'No Year Found',
          closeDropDownOnSelection: false,
          showSelectedItemsAtTop: false,
          defaultOpen: false
        };
    } 
    WHLocationSetting() {
        this.WHLocationSettings = {
            singleSelection: false,
            idField: 'whId',
            textField: 'whName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Location Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    WHLocation() {
        this.whLocationDdl = [{ WHId: "1", WHName: "WHName1" }, { WHId: "2", WHName: "WHName2" }]
    }

    AddRowWHLocationSetting() {
        this.AddRowWHLocationSettings = {
            singleSelection: true,
            idField: 'whCode',
            textField: 'whName',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Location Found',
            closeDropDownOnSelection: true,
        };
    }
    AddRowRequestTypeSetting() {
        this.AddRowRequestTypeSettings = {
            singleSelection: true,
            idField: 'requestType',
            textField: 'requestType',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Request Type Found',
            closeDropDownOnSelection: true,
        };
    }
    AddRowPackSizeSetting() {
        this.AddRowPackSizeSettings = {
            singleSelection: true,
            idField: 'packSize',
            textField: 'packSize',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Pack Size Found',
            closeDropDownOnSelection: true,

        };
    }


    AddRowProductSetting() {
        this.AddRowProductSettings = {
            singleSelection: true,
            idField: 'productCode',
            textField: 'productName',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Product Found',
            closeDropDownOnSelection: true,

        };
    }

    AddRowMonthSetting() {
        this.AddRowMonthSettings = {
            singleSelection: true,
            idField: 'monthId',
            textField: 'monthName',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Month Found',
            closeDropDownOnSelection: true,

        };
    }
    AddRowYearSetting() {
        this.AddRowYearSettings = {
            singleSelection: true,
            idField: 'yearId',
            textField: 'yearName',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Year Found',
            closeDropDownOnSelection: true,

        };
    }

    AddRowOriginLocationSetting() {
        this.AddRowOriginLocationSettings = {
            singleSelection: true,
            idField: 'code',
            textField: 'name',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Origin Found',
            closeDropDownOnSelection: true,

        };
    }


    ProductSetting() {
        this.ProductSettings = {
            singleSelection: false,
            idField: 'productId',
            textField: 'productName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Product Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }

    MonthSetting() {
        this.MonthSettings = {
            singleSelection: false,
            idField: 'monthId',
            textField: 'monthName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Month Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    
    OriginLocationSetting() {
        this.OriginLocationSettings = {
            singleSelection: false,
            idField: 'code',
            textField: 'name',
            enableCheckAll: false,
            clearSearchFilter: true,
            itemsShowLimit: 10,
            noDataAvailablePlaceholderText: 'No Origin Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }


    GetWarehouseData(pageNumber: number){
        this.loader = 'block';
        debugger;
        this.isDisabledPrevious = true;
        this.isDisabledNext = false;
        this.userId = localStorage.getItem('dsu_userId');
        let year=0;
        let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        let month = Array.prototype.map.call(this.monthSelect.selectedItems, function (item) { return item.id; }).join(",");
        year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        let whLocation = Array.prototype.map.call(this.WHLocationItem.selectedItems, function (item) { return item.id; }).join(",");
        this.dispatchToWarehouse.GetDispatchToWarehouse(whLocation, product,year, month, this.userId,pageNumber)
                .subscribe((response) => {
                    if (response.status) {
                        //this.dynamicAddRow = [];
                        this.defaultView = false;
                        this.dispatchToSDWarehouseObj = response.data.dispatchToWarehouseList;
                        this.pagination = response.data.pagination;
                        this.totalRecord = this.pagination.totalRecord;
                        this.currentPage = this.pagination.currentPage;
                        this.lastPage = this.pagination.lastPage;
                        this.recordsOnCurrentPage = this.pagination.recordOnPage;
                        this.endRecord = this.recordsOnCurrentPage;
                        this.startRecord = 1;
                        if (this.currentPage == 1) {
                            localStorage.setItem("numberOfRecordsOnFirstPage", this.recordsOnCurrentPage.toString());
                        }
                        if (this.currentPage > 1) {
                            this.isDisabledPrevious = false;
                            this.startRecord = (this.currentPage - 1) * parseInt(localStorage.getItem("numberOfRecordsOnFirstPage"), 10) + 1;
                            this.endRecord = this.startRecord + this.recordsOnCurrentPage - 1;
                        }
                        if (this.currentPage == this.lastPage || this.totalRecord == 0) {
                            this.isDisabledNext = !this.isDisabledNext;
                            this.recordsOnCurrentPage = this.totalRecord;
                        } if (this.dispatchToSDWarehouseObj.length == 0) {
                            this.startRecord = 0;
                            this.endRecord = 0;
                            this.recordsOnCurrentPage = 0;
                        }

                        console.log(response.data);
                    }
                    else {
                        this.dispatchToSDWarehouseObj= [];
                        this.pagination = [];
                        this.totalRecord = 0;
                        this.currentPage = 0;
                        this.lastPage = 0;
                        this.recordsOnCurrentPage = 0;
                        this.endRecord = 0;
                        this.startRecord = 0;
                        this.isDisabledNext = true;
                        this.isDisabledPrevious = true
                       // this.toastr.error(response.message);
                    }
                    this.loader = 'none';
                }, error => {
                    this.loader = 'none';
                });
        }
    

    GetWarehouseLocationData(userId: string, roleId: string, IsOnInit: string) {
        let obj: DropDownRequest = new DropDownRequest();

        this.loader = 'block';
        obj.UserId = this.userId;
        obj.Role = this.roleId;
        obj.Flag = IsOnInit;
        obj.SD = '';
        this.ddlServices.getWarehouseLocationDropDown(obj)
            .subscribe((response) => {
                if (response.status) {

                    this.ddlResponseWH.warehouseLocation = response.data.warehouse;
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }


    reset() {
        this.defaultValue = 'none';
        if (this.productSelect != undefined) {
            this.productSelect.selectedItems = [];
        }
        if (this.monthSelect != undefined) {
            this.monthSelect.selectedItems = [];
        }
        
        if (this.WHLocationItem != undefined) {
            this.WHLocationItem.selectedItems = [];
        }
        
        if (this.year != undefined)
        {
            class YearItemList{
                id: any;
                text: any;
            }
            let requiredItem: YearItemList[] = [];
            var obj = {
              id : this.ddlResponse.year[0].currentrequirementYear,
              text: this.ddlResponse.year[0].currentrequirementYear
            }
            requiredItem.push(obj)
            this.year.selectedItems=requiredItem;
        }
        this.defaultView = true;
    }

    DownloadExcelForDispatchToWarehouse() {
        this.loader = 'block';
        let today = new Date();
        let month1 = '0' + (today.getMonth() + 1).toString().slice(-2);
        let year = today.getFullYear();
        let formattedDate = today.getDate() + "_" + month1 + "_" + year;
        let yearfilter=0;
        this.userId = localStorage.getItem('dsu_userId');
        let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        let month = Array.prototype.map.call(this.monthSelect.selectedItems, function (item) { return item.id; }).join(",");
        let whLocation = Array.prototype.map.call(this.WHLocationItem.selectedItems, function (item) { return item.id; }).join(",");
        yearfilter = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        this.dispatchToWarehouse.DownloadExcelForDispatchToWarehouse(whLocation, product, month,yearfilter, this.userId,0)
        .subscribe(success => {
            if (success.ok = true) {
              var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
              saveAs(blob, this.userName +"_"+year+ "_DispatchToWarehouse_" + formattedDate + ".xlsx");
            }
            this.loader = 'none';
          },
            err => {
              this.toastr.error("No data available for download");
              this.loader = 'none';
            });
    }


    UploadExcel(files: File[]) {
        this.files = [];
        this.files = files;
        let fileNameParts: string[] = files[0].name.split('.');
        let fileType = files[0].name.split('.')[fileNameParts.length - 1];
        let UserId = localStorage.getItem('dsu_userId');
        let yearfilter=0;
        yearfilter = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        
        if (fileType != 'xls' && fileType != 'xlsx') {
            this.toastr.error("Please Select Valid File Type.");
            return false;
        }
        
        this.loader = 'block';
        this.document.file = <File>this.files[0];
        
        this.dispatchToWarehouse.uploadExcel(this.document.file, UserId,yearfilter)
            .subscribe((resData: any) => {
                if (resData.status == true) {
                    this.toastr.success(resData.message);
                }
                else {
                    this.toastr.error(resData.message);
                }
                this.file.nativeElement.value = '';
                debugger;
                this.GetWarehouseData(1);
            }, error => {
                this.file.nativeElement.value = '';
                this.loader = 'none';
                this.toastr.error('Some Problem Occured,Please try again later.');
            });

    }

    DownloadDispatchHistory() {
        this.loader = 'block';
        let today = new Date();
        let month1 = '0' + (today.getMonth() + 1).toString().slice(-2);
        let year = today.getFullYear();
        let formattedDate = today.getDate() + "_" + month1 + "_" + year;
        let yearfilter=0;
        yearfilter = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        
        this.userId = localStorage.getItem('dsu_userId');
        let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        let month = Array.prototype.map.call(this.monthSelect.selectedItems, function (item) { return item.id; }).join(",");
        let whLocation = Array.prototype.map.call(this.WHLocationItem.selectedItems, function (item) { return item.id; }).join(",");
        this.dispatchToWarehouse.DownloadDispatchHistory(whLocation, product, month, this.userId,yearfilter)
        .subscribe(success => {
            if (success.ok = true) {
              var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
              saveAs(blob, this.userName +"_"+year+ "_WarehouseToSDDispatchHistory_" + formattedDate + ".xlsx");
            }
            this.loader = 'none';
          },
            err => {
              this.toastr.error("No data available for download");
              this.loader = 'none';
            });
    }

    GetDispatchToWarehouse() {
        this.GetWarehouseData(1);
        let isValid = true;
        this.userId = localStorage.getItem('dsu_userId');
        let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        let month = Array.prototype.map.call(this.monthSelect.selectedItems, function (item) { return item.id; }).join(",");
        let whLocation = Array.prototype.map.call(this.WHLocationItem.selectedItems, function (item) { return item.id; }).join(",");
        let year= Array.prototype.map.call(this.year.selectedItems,function (item){return item.id;}).join(",");

      //  if (isValid) {
            this.loader = 'block';
            this.dispatchToWarehouse.GetWarehouseFilter(whLocation, product, month, this.userId,year)
                .subscribe((response) => {
                    if (response.status) {
                        this.dynamicAddRow = [];
                        this.defaultView = false;
                        debugger;
                        this.dispatchToSDObj = response.data;
                        // if(this.dispatchToSDObj.stockAvailable.length <= 0){
                        //     this.toastr.error("No data found");
                        // }
                        if (this.dispatchToSDWarehouseObj.length > 0) {
                            //for (let i = 0; i < this.dispatchToSDWarehouseObj.length; i++) {
                                this.AddRow();
                            //}
                        }
                        this.AddRowProductSetting();
                        this.AddRowPackSizeSetting();
                        //this.AddRowMonthSetting();
                        //this.AddRowOriginLocationSetting();
                        // if (this.dispatchToSDObj.stockEdit.length > 0) {
                        //     this.AddRow(0);
                        // }
                        console.log(response.data);
                    }
                    else {
                        this.toastr.error(response.message);
                    }
                    this.loader = 'none';
                }, error => {
                    this.loader = 'none';
                });
       // }

    }

    AddRowForEdit(index, data) {
        var datePipe = new DatePipe("en-US");
        let mfgDate = data.mfgDate;
        data.mfgDate = datePipe.transform(mfgDate, 'dd/MMM/yyyy');
        let expDate = data.expDate;
        data.expDate = datePipe.transform(expDate, 'dd/MMM/yyyy');
        let invDate = data.invDate;
        data.invDate = datePipe.transform(invDate, 'dd/MMM/yyyy');

        this.newAddRow =
        {
            Id: data.id,
            WarehouseCode: data.warehouseCode,
            WarehouseLocation: data.warehouseLocation,
            ItemCode: data.itemCode,
            ItemName: data.itemName,
            PackSize: data.packSize,
            PackMRP: data.packMRP,
            BatchNo: data.batchNo,
            Qty: data.qty,
            LR: data.lr,
            CarrierDetail: data.CarrierDetail,
            OriginLocation: data.originLocation,
            MFGDate: data.mfgDate,
            EXPDate: data.expDate,
            DocNo: data.docNo,
            InvNo: data.invNo,
            InvDate: data.invDate,
            IsEdit: false

        }


        this.productPackSize.push(0);
        this.productPackSize[index] = [];
        for (let i = 0; i < this.dispatchToSDObj.dsAddStock.packSize.length; i++) {
            if (this.dispatchToSDObj.dsAddStock.packSize[i].productCode == data.itemCode) {
                let packSize: any = {};
                packSize.packSize = this.dispatchToSDObj.dsAddStock.packSize[i].packSize;
                this.productPackSize[index].push(packSize);


            }
        }
        this.dynamicAddRow.push(this.newAddRow);

    }


    AddRow() {
        this.newAddRow =
        {
            Id: 0,
            WarehouseCode: "",
            WarehouseLocation:"",
            ProductCode:"",
            PackSize:"",
            PackMRP: 0,
            BatchNo: "",
            Qty: 0.0,
            LR: "",
            OriginLocation: "",
            CarrierDetail: "",
            MFGDate: "",
            EXPDate: "",
            InvNo: "",
            InvDate: "",
            Month:"",
            RequirementYear:"",
            OriginLocationName:"",
            IsEdit: true
        }
        this.productPackSize.push(0);
        this.dynamicAddRow.push(this.newAddRow);
        return true;
    }

    
    AddDataRow(i) {
        this.newAddRow =
        {
            Id: 0,
            WarehouseCode: "",
            WarehouseLocation:"",
            ProductCode:"",
            PackSize:"",
            PackMRP: 0,
            BatchNo: "",
            Qty: 0.0,
            LR: "",
            OriginLocation: "",
            CarrierDetail: "",
            MFGDate: "",
            EXPDate: "",
            InvNo: "",
            InvDate: "",
            Month:"",
            RequirementYear:"",
            OriginLocationName:"",
            IsEdit: true
        }
        this.productPackSize.push(0);
        this.dynamicAddRow.push(this.newAddRow);
        return true;
    }

    DeleteRow(index) {
        if (this.dynamicAddRow.length == 1) {
            this.toastr.error("Can't delete the row when there is only one row");
            return false;
        }
        else {
            this.dynamicAddRow.splice(index, 1);
            return true;
        }
    }

    IsAlphaNumeric(event: any) {
        var newKeyCode = event.keyCode;
        return ((newKeyCode > 64 && newKeyCode < 91) || (newKeyCode > 96 && newKeyCode < 123) || (newKeyCode == 8 || newKeyCode == 32) || (newKeyCode >= 48 && newKeyCode <= 57) || newKeyCode == 59);
    }

    onAddRowProductSelect(item: any, index: any) {
        this.productPackSize[index] = [];

        for (let i = 0; i < this.dispatchToSDObj.dsAddStock.packSize.length; i++) {
            if (this.dispatchToSDObj.dsAddStock.packSize[i].productCode == item.productCode) {
                let packSize: any = {};
                packSize.packSize = this.dispatchToSDObj.dsAddStock.packSize[i].packSize;
                this.productPackSize[index].push(packSize);


            }
        }

        this.dynamicAddRow[index].ProductCode = item.productCode;
        this.dynamicAddRow[index].productName = item.productName;


    }
    onAddRowProductDeSelect(item: any, index: any) {
        this.productPackSize[index] = [];
    }

    onAddRowPackSize(item: any, index: any) {
        this.dynamicAddRow[index].PackSize = item.packSize;
    }
    onAddRowPackSizeDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].PackSize = "";
    }
    onAddRowMonth(item: any, index: any) {
        this.dynamicAddRow[index].Month = item.monthId;
    }
    onAddRowMonthDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].Month = "";
    }
    onAddRowYear(item: any, index: any) {
        debugger
        this.dynamicAddRow[index].RequirementYear = item.year;
    }
    onAddRowYearDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].RequirementYear = "";
    }
    onAddRowWHLocation(item: any, index: any) {
        this.dynamicAddRow[index].WarehouseCode = item.whCode;
        this.dynamicAddRow[index].WarehouseLocation = item.whName;
    }
    onAddRowRequestType(item: any, index: any) {
        debugger;
        this.dynamicAddRow[index].RequestTypes = item.requestType;
    }

    onAddRowOriginLocation(item: any, index: any) {
        this.dynamicAddRow[index].OriginLocation = item.code;
        var name=  item.name.split('(');
        this.dynamicAddRow[index].OriginLocationName = name[0];
    }

    onAddRowOriginLocationDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].OriginLocation = "";
        this.dynamicAddRow[index].OriginLocationName = "";
    }

    onAddRowWHLocationDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].WarehouseCode = "";
        this.dynamicAddRow[index].WarehouseLocation = "";
    }
    onAddRowRequestTypeDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].RequestTypes = "";
    }
    onDateSelectEXPDate(newValueEXPDate, index) {
        this.dynamicAddRow[index].MFGDate
        let nwValue = newValueEXPDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy')
        this.dynamicAddRow[index].EXPDate = nwValue;
    }
    onDateSelectMFGDate(newValueEXPDate, index) {
        let nwValue = newValueEXPDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy')
        this.dynamicAddRow[index].MFGDate = nwValue;
    }
    
    onDateSelectINVDate(newValueINVDate, index) {
        let nwValue = newValueINVDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy')
        this.dynamicAddRow[index].InvDate = nwValue;
    }

    ValidateDispatchToWarehouse(dynamicAddRow: any) {

        this.displayReject = 'none';
        let isValid = true;
        for (let i = 0; i < dynamicAddRow.length; i++) {
            if (!Boolean(dynamicAddRow[i].WarehouseLocation)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].RequestTypes)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].ProductCode)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].PackSize)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            // if (!Boolean(dynamicAddRow[i].PackMRP)) {
            //     isValid = false;
            //     this.toastr.error("Please fill all required fields.");
            //     return false;
            // }
            if (!Boolean(dynamicAddRow[i].BatchNo)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].Qty)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].LR)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].OriginLocation)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].CarrierDetail)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            // if (!Boolean(dynamicAddRow[i].MFGDate)) {
            //     isValid = false;
            //     this.toastr.error("Please fill all required fields.");
            //     return false;
            // }
            if (!Boolean(dynamicAddRow[i].EXPDate)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].InvNo)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].InvDate)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].Month)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].RequirementYear)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            let mfgDate = new Date(dynamicAddRow[i].MFGDate);
            let expDate = new Date(dynamicAddRow[i].EXPDate);
            if (expDate <= mfgDate) {
                isValid = false;
                this.toastr.error("EXP Date must be greater than MFG Date.");
                return false;
            }
            // let arr1 = dynamicAddRow[i], arr2 = dynamicAddRow[i + 1];
            // let data1=JSON.stringify(arr1),data2=JSON.stringify(arr2);
            // if (data1 === data2) {
            //     isValid = false;
            //     this.toastr.error("Two rows cannot be identical.");
            //     return false;
            // }
            
        }
        if (isValid) {

            this.displayReject = 'block';
        }


        //console.log(dynamicAddRow);
    }
    closePopup(commentModal: string) {
        this.displayReject = 'none';
        this.displayEdit = 'none';
    }

    SaveDispatchToWarehouse(dynamicAddRow: any) {
        debugger
       if(dynamicAddRow.length===0)
       {
        this.toastr.error('Please Add Row to Dispatch.');
        this.displayReject = 'none';
        return 
       }
        this.loader = 'block';
        this.displayReject = 'none';
        this.userId = localStorage.getItem('dsu_userId');
        this.dispatchToWarehouse.SaveDispatchToWarehouse(dynamicAddRow, this.userId)
            .subscribe((response) => {
                if (response.status) {
                    this.defaultView = true;
                    this.toastr.success(response.message);
                }
                else {
                    this.toastr.error(response.message);
                }
                this.loader = 'none';
            }, error => {
                this.loader = 'none';
                this.toastr.error('Some Problem Occured,Please try again later.');
            });
          //  this.GetWarehouseData(0);
    }

    EditRow(stock: any) {
        //this.editStockIn = stock;
        this.editStockIn = this.DeepCopy(stock);
        this.editStockIn.productId = this.editStockIn.productCode;
        this.editStockIn.whLocation = this.editStockIn.whName;
        this.displayEdit = "block";
        let WHSelected = { whCode: this.editStockIn.whCode, whName: this.editStockIn.whName };
        



    }

    onEditRowProductSelect(item: any, index: any) {
        this.editProductPackSize = [];

        for (let i = 0; i < this.dispatchToSDObj.dsAddStock.packSize.length; i++) {
            if (this.dispatchToSDObj.dsAddStock.packSize[i].productCode == item.productCode) {
                let packSize: any = {};
                packSize.packSize = this.dispatchToSDObj.dsAddStock.packSize[i].packSize;
                this.editProductPackSize.push(packSize);


            }
        }

        this.editStockIn.PackSizeSelectedList = [];

        this.editStockIn.productId = item.productCode;
        this.editStockIn.productName = item.productName;


    }

    onEditRowProductDeSelect(item: any, index: any) {
        this.editStockIn.productName = "";
        this.editStockIn.productId = "";
    }

    onEditRowPackSize(item: any, index: any) {
        this.editStockIn.packSize = item.packSize;
    }
    onEditRowPackSizeDeSelect(item: any, index: any) {
        this.editStockIn.packSize = "";
    }
    onEditRowWHLocation(item: any, index: any) {
        this.editStockIn.whCode = item.whCode;
        this.editStockIn.whLocation = item.whName;
    }

    onEditRowWHLocationDeSelect(item: any, index: any) {
        this.editStockIn.whCode = "";
        this.editStockIn.whName = "";
    }

    DeepCopy(obj: any): any {
        let clonedObject;

        if (obj === null || typeof obj !== 'object') {
            return obj;
        }
        if (obj instanceof Array) {
            clonedObject = [];
            for (let i = 0; i < obj.length; i++) {
                clonedObject[i] = this.DeepCopy(obj[i]);
            }
            return clonedObject;
        }
        if (obj instanceof Date) {
            clonedObject = new Date(obj.valueOf());
            return clonedObject;
        }
        if (obj instanceof RegExp) {
            clonedObject = RegExp(obj.source, obj.flags);
            return clonedObject;
        }
        if (obj instanceof Object) {
            clonedObject = new obj.constructor();
            for (const attr in obj) {
                if (obj.hasOwnProperty(attr)) {
                    clonedObject[attr] = this.DeepCopy(obj[attr]);
                }
            }
            return clonedObject;
        }
    }

    EditDispatchToWarehouse(stockIn) {
        let isValid = true;
        if (!Boolean(stockIn.whCode)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.whLocation)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.productId)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.productName)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.packSize)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.stockReceiptDate)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.receivedThrough)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.receivedFrom)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.batchNo)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.qty)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        
        if (!Boolean(stockIn.mfgDate)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.docNo)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.expDate)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.invNo)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.invDate)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        let mfgDate = new Date(stockIn.mfgDate);
        let expDate = new Date(stockIn.expDate);
        if (expDate <= mfgDate) {
            isValid = false;
            this.toastr.error("EXP Date must be greater than MFG Date.");
            return false;
        }

        this.displayEdit = 'none';
        this.loader = 'block';

        if (isValid) {
            stockIn.userId = localStorage.getItem('dsu_userId');
            console.log(stockIn);
            this.dispatchToWarehouse.UpdateStockIn(stockIn)
                .subscribe((response) => {

                    if (response.status) {
                        this.defaultView = true;
                        this.toastr.success(response.message);
                        //this.GetWarehouseData(1);
                        this.GetDispatchToWarehouse();
                    }
                    else {
                        this.toastr.error(response.message);
                    }
                    this.loader = 'none';
                }, error => {
                    this.loader = 'none';
                    this.toastr.error('Some Problem Occured,Please try again later.');
                });

        }
    }
    remarkContent: string = '';
    remarkDate: string = '';
    isPartiallyclosed: boolean;
    onImageClick(remark: any,remainingQty: any) {
    
      const closedContent = remark.split('!split!');
      this.remarkDate = closedContent[0];
      const processedRemark = closedContent[1].replace(/\\n/g, '\n');
      
      this.remarkContent = processedRemark.replace(/\n/g, '<br>');
  
      if(remainingQty != 0.00)
      {
        this.isPartiallyclosed = true
      }
      else{
        this.isPartiallyclosed = false
      }
      this.cd.detectChanges();
    }
    onEditClick(stock: any){
        this.remarkInput = '';
        this.hiddenFMCSTCloseModel = stock;
    }
    SubmitClosedRequest(){
        debugger;
        this.loader = 'block';
        if(this.remarkInput == undefined || this.remarkInput.length < 1)
        {
            this.loader = 'none';
            this.toastr.error('Please Enter Remark');
            return;
        }
        const closeBtn = document.getElementById('close-dis-popup');
        if (closeBtn) {
        closeBtn.click();  // Simulate the click event
        }
        this.displayReject = 'none';
        this.userId = localStorage.getItem('dsu_userId');
        this.hiddenFMCSTCloseModel ={
            ...this.hiddenFMCSTCloseModel, 
            Remark: this.remarkInput,
            Year: this.currentYear,
            UserId:this.userId
        }
        console.log(this.hiddenFMCSTCloseModel);
        debugger;
        this.dispatchToWarehouse.FMCSTClosedRequest(this.hiddenFMCSTCloseModel)
            .subscribe((response) => {
                if (response.status) {
                    this.defaultView = true;
                    this.toastr.success(response.message);
                }
                else {
                    this.toastr.error(response.message);
                }
                this.loader = 'none';
                this.GetWarehouseData(1);
            }, error => {
                this.loader = 'none';
                this.toastr.error('Some Problem Occured,Please try again later.');
            });
    }
}